import React from "react";
import {
  Box,
 Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Chip,
} from "@mui/material";
import NatureIcon from "@mui/icons-material/Nature";

function FloraCard({ plant }) {
  return (
    <Card
      sx={{
        mb: 4,
        borderRadius: 5,
        overflow: "hidden",
        background:
          "linear-gradient(135deg,#ffffff 0%,#f7fcf8 50%,#eef8ff 100%)",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 10px 35px rgba(0,0,0,0.08)",
        transition: "all .35s ease",

        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 20px 45px rgba(0,0,0,0.15)",
        },
      }}
    >
      <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  sx={{
    minHeight: 280,
    p: 2,
  }}
>
        {/* Plant Image */}
        <Grid item xs={12} md={4}>
          <CardMedia
            component="img"
            image={plant.image}
            alt={plant.common_name}
            sx={{
              height: {
                xs: 240,
                md: 240,
              },
              width: "100%",
              borderRadius: 4,
              objectFit: "cover",
            }}
          />
        </Grid>

        {/* Plant Details */}
        <Grid item xs={12} md={5}>
          <CardContent
            sx={{
              px: 4,
            }}
          >
            <Typography
              variant="h4"
              fontWeight={700}
              color="#0B3C5D"
              gutterBottom
            >
              {plant.common_name}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontStyle: "italic",
                color: "#2E7D32",
                mb: 3,
              }}
            >
              {plant.scientific_name}
            </Typography>

            {/* <Chip
              icon={<NatureIcon />}
              label={plant.family}
              color="success"
              sx={{
                fontWeight: 600,
                fontSize: 15,
                px: 1,
                borderRadius: 5,
              }}
            /> */}
          </CardContent>
        </Grid>

        {/* QR Code - Right End */}
        {/* QR Code */}
{/* QR Code */}
<Grid
  item
  xs={12}
  md={3}
  sx={{
    display: "flex",
    justifyContent: {
      xs: "center",    // Center on mobile
      md: "flex-end",  // Right on desktop/laptop/projector
    },
    alignItems: "center",
    ml: { md: "auto" },
    px: { xs: 2, md: 3 },
  }}
>
  <Box
    sx={{
      width: {
        xs: "100%",
        md: 190,
      },
      maxWidth: {
        xs: 320,   // Keeps the card centered on mobile
        md: 190,
      },
      mx: {
        xs: "auto", // Center the box
        md: 0,
      },
      p: 2,
      bgcolor: "#fff",
      borderRadius: 4,
      border: "1px solid #e0e0e0",
      boxShadow: "0 8px 24px rgba(0,0,0,.08)",
      textAlign: "center",
    }}
  >
    <Box
      component="img"
      src={plant.qr_code}
      alt="QR Code"
      sx={{
        width: {
          xs: 180,   // Fixed size on mobile
          md: 150,
        },
        height: {
          xs: 180,
          md: 150,
        },
        display: "block",
        mx: "auto",  // Center the image
      }}
    />

    <Typography
      variant="body2"
      sx={{
        mt: 2,
        fontWeight: 600,
        color: "#666",
      }}
    >
      📱 Scan to View Plant Details
    </Typography>
  </Box>
</Grid>
      </Grid>
    </Card>
  );
}

export default FloraCard;